import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnDestroy,
  ViewChild
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { finalize } from 'rxjs/operators';

import { AuthService, GlobalMessageService, GlobalMessageType } from '@spartacus/core';
import { KnBrConsentManagementService } from '../service/kn-br-consent-management.service';

@Component({
  selector: 'kn-br-consent-management-popup',
  templateUrl: './kn-br-consent-management-popup.component.html',
  styleUrls: ['./kn-br-consent-management-popup.component.scss'],
  standalone: false
})
export class KnBrConsentManagementPopupComponent implements AfterViewInit, OnDestroy {
  @Input() user: any;

  isLoading = false;

  consentControl = new FormControl({ value: false, disabled: true });

  isScrolledToBottom = false;

  @ViewChild('scrollTerms', { static: false }) scrollTermsRef?: ElementRef<HTMLElement>;

  private scrollTermsEl?: HTMLElement;
  private boundOnScroll = this.onTermsScroll.bind(this);

  constructor(
    private activeModal: NgbActiveModal,
    private consentManagementService: KnBrConsentManagementService,
    private authService: AuthService,
     private globalMessageService: GlobalMessageService
  ) {}

  ngAfterViewInit(): void {
    this.scrollTermsEl = this.scrollTermsRef?.nativeElement;

    if (!this.scrollTermsEl) {
      return;
    }

    this.updateScrolledToBottom();
    this.scrollTermsEl.addEventListener('scroll', this.boundOnScroll, { passive: true });
  }

  ngOnDestroy(): void {
    if (this.scrollTermsEl) {
      this.scrollTermsEl.removeEventListener('scroll', this.boundOnScroll as any);
    }
  }

  private onTermsScroll(): void {
    this.updateScrolledToBottom();
  }

  private updateScrolledToBottom(): void {
    if (!this.scrollTermsEl) {
      return;
    }

    const tolerancePx = 2;
    const { scrollTop, scrollHeight, clientHeight } = this.scrollTermsEl;

    const reachedBottom = scrollTop + clientHeight >= scrollHeight - tolerancePx;

    if (reachedBottom && !this.isScrolledToBottom) {
      this.isScrolledToBottom = true;
      this.consentControl.enable({ emitEvent: false });
    }
  }

  proceed(): void {
    if (this.isLoading || this.consentControl.disabled || !this.consentControl.value) {
      return;
    }

    this.isLoading = true;

    const userId = this.user?.uid;
    if (!userId) {
      this.isLoading = false;
      return;
    }

    this.consentManagementService
      .setConsentAcceptedTrue(userId)
      .pipe(
        finalize(() => {
          this.isLoading = false;
        })
      )
      .subscribe({
        next: () => {
          this.activeModal.close(true);
        },
        error: () => {
          this.logout();
        }
      });
  }

  decline(): void {
    this.logout();
     this.globalMessageService.add(
      'Access to the portal requires acceptance of the Terms & Conditions.',
      GlobalMessageType.MSG_TYPE_ERROR
    );
  }

  private logout(): void {
    this.activeModal.dismiss(false);

    setTimeout(() => {
      this.authService.logout();
    });
  }
}